import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e4ee13e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "settings-overlay-container" };
const _hoisted_2 = ["value"];
const _hoisted_3 = _withScopeId(() => _createElementVNode("p", null, "Flight Route", -1));
const _hoisted_4 = ["value"];
const _hoisted_5 = _withScopeId(() => _createElementVNode("p", null, "Automatic Servers Refresh", -1));
const _hoisted_6 = ["value"];
const _hoisted_7 = _withScopeId(() => _createElementVNode("p", null, "Display Active Airports", -1));
const _hoisted_8 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_9 = _withScopeId(() => _createElementVNode("p", { id: "settings-note" }, " Some settings may need a window refresh to be applied. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                value: _ctx.FLIGHT_ROUTE,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.boxSelected) = $event))
            }, null, 8, _hoisted_2), [
                [_vModelCheckbox, _ctx.boxSelected]
            ]),
            _hoisted_3
        ]),
        _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                value: _ctx.AUTOMATIC_REFRESH,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.boxSelected) = $event))
            }, null, 8, _hoisted_4), [
                [_vModelCheckbox, _ctx.boxSelected]
            ]),
            _hoisted_5
        ]),
        _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                value: _ctx.DISPLAY_ACTIVE_AIRPORTS,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.boxSelected) = $event))
            }, null, 8, _hoisted_6), [
                [_vModelCheckbox, _ctx.boxSelected]
            ]),
            _hoisted_7
        ]),
        _hoisted_8,
        _hoisted_9
    ]));
}
